import {Directive, input, TemplateRef} from "@angular/core";
import {Assessable, AssessableItem} from "@models";

export type AssessableItemData<TItemType extends AssessableItem> = {
	dragHandle: TemplateRef<void>;
	item: TItemType;
	groupItems: TItemType[];
	groupId: string | null;
	index: number;
	groupIndex: number | null;
	length: number;
};
export type AssessableItemTemplateContext<TItemType extends AssessableItem> = {
	$implicit: AssessableItemData<TItemType>;
};

@Directive({
	selector: "ng-template[assessableItemTemplate]",
	standalone: true,
})
export class AssessableItemTemplateDirective<T extends AssessableItem> {
	// this input serves as a type hint for the context, it enables type checking in the template
	assessable = input.required<Assessable<T>>();

	static ngTemplateContextGuard<TContext extends AssessableItem>(
		dir: AssessableItemTemplateDirective<TContext>,
		ctx: unknown,
	): ctx is AssessableItemTemplateContext<TContext> {
		return true;
	}
}
